import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import {
    FinanceSummary,
    PurchasePayment,
} from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export interface PurchaseFinanceData {
    summary: FinanceSummary | null
    payments: PurchasePayment[]
}

export const usePurchaseFinance = (processId?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchaseFinance
    )
    const [data, setData] = useState<PurchaseFinanceData>({
        summary: null,
        payments: [],
    })
    const [loading, setLoading] = useState<boolean>(false)

    const load = useCallback(async () => {
        if (!processId) return
        setLoading(true)
        try {
            const result = await useCase.execute(processId)
            setData({
                summary: result?.summary ?? null,
                payments: result?.payments ?? [],
            })
        } catch {
            // sem purchase ainda → financeiro vazio é estado válido
            setData({ summary: null, payments: [] })
        }
        setLoading(false)
    }, [useCase, processId])

    useEffect(() => {
        load()
    }, [load])

    return { ...data, loading, reload: load }
}
